import React, { useEffect, useState } from 'react';

import lunchLogo from '../../../img/logo-lunch-team.svg';

import '../PrivacyTerms/privacyTerms.scss';

export function TermsAndConditions() {
  const [content, setContent] = useState();

  const termsURL =
    'https://s3-eu-west-1.amazonaws.com/lunchteam-terms-conditions/staging/en/terms_conditions1.1.txt';

  const getTermsConditions = async () => {
    const result = await fetch(termsURL).then(result => result.text());

    setContent(result);
  };

  useEffect(() => {
    getTermsConditions();
  }, []);

  return (
    <main className="main">
      <header className="head">
        <img src={lunchLogo} alt="Lunch Team Logo" />
      </header>

      <div className="content-terms">
        <a href="/Menu" className="back-link">
          Back
        </a>
        <h2>Terms and Conditions</h2>
        <div
          className="text-content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Landing/TermsAndConditions/index.js